
<div class="data-printer-v2" *ngIf="categories">
    <div class="category" *ngFor="let category of categories" [style.minWidth]="category.minWidth" [style.width]="category.width" [style.maxWidth]="category.maxWidth">
        <h3 class="category-name" *ngIf="category.name">
            {{ category.name }}
        </h3>
        <div class="item" *ngFor="let item of category.items">
            <span class="label" *ngIf="item.label" [style.minWidth]="category.labelWidth" [style.width]="category.labelWidth">{{ item.label }}:</span>
            <span class="value {{ item.className ? item.className : '' }}" *ngIf="item.value !== undefined && item.value !== null && item.value !== ''" [innerHTML]="parseByType(item)" [style.textAlign]="item.alignment"></span>
            <span class="value {{ item.className ? item.className : '' }}" *ngIf="(item.value === undefined || item.value === null || item.value === '') && !item.template" [style.textAlign]="item.alignment">-</span>
            <ng-container [ngTemplateOutlet]="item.template" [ngTemplateOutletContext]="item.templateParams ? item.templateParams : {}" *ngIf="item.template"></ng-container>
        </div>
    </div>
</div>
